import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress, TextField } from "@material-ui/core";
import formHandlerHOC, { isInvalidField } from '../../../../components/FormHandlerHOC';
import If from '../../../../components/If';
import Fvt from '../../../../components/FieldValidationText';
import CustomLink from "../../../../components/CustomLink";
import _handleSubmit from '../submitEventHandler';
import ErrorMessage from "../../../../components/ErrorMessage";

const _handleEditionClick = (onEditionClick, { editable, resetForm }) => {
    if (editable) {
        resetForm();
    }
    onEditionClick();
};

function ProfileEditor({
                           classes, editable, requestInProgress,
                           onEditionClick, onSubmit, onFormChange, resetForm,
                           formState, validateForm, getFormData, getFormStateSync, generalError
                       }) {
    const { isValid, isPristine, name, surnames, phone, email } = formState;
    return (
        <form action="#"
              onSubmit={e => _handleSubmit(e, onSubmit, { formState, validateForm, getFormData, getFormStateSync })}
              className={classes.profileEditorContainer}>

            <div className="editionContainer">
                <CustomLink onClick={() => _handleEditionClick(onEditionClick, { editable, resetForm })}
                            disabled={requestInProgress}>
                    {editable ? 'CANCEL' : 'EDIT'}
                </CustomLink>
            </div>

            <TextField name="name"
                       value={name.value}
                       onChange={onFormChange}
                       error={isInvalidField(name)}
                       disabled={!editable}
                       label='Name' fullWidth margin="normal"/>
            <Fvt>{name.primaryMessage}</Fvt>

            <TextField name="surnames"
                       value={surnames.value}
                       onChange={onFormChange}
                       error={isInvalidField(surnames)}
                       disabled={!editable}
                       label='Last Name' fullWidth margin="normal"/>
            <Fvt>{surnames.primaryMessage}</Fvt>

            <TextField name="phone"
                       value={phone.value}
                       onChange={onFormChange}
                       error={isInvalidField(phone)}
                       disabled={!editable}
                       placeholder="(###) ###-####"
                       label='Phone Number' fullWidth margin="normal"/>
            <Fvt>{phone.primaryMessage}</Fvt>

            <TextField disabled
                       value={email.value}
                       label='Email Address' fullWidth margin="normal"/>

            <If as={ErrorMessage} condition={!!generalError}>
                {generalError}
            </If>

            <Button type='submit'
                    fullWidth
                    variant="contained"
                    color="secondary"
                    className="submitButton"
                    disabled={!isValid || isPristine || requestInProgress || !editable}>
                Save <If as={CircularProgress} condition={requestInProgress} size={20}/>
            </Button>
        </form>
    );
}

ProfileEditor.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    requestInProgress: PropTypes.bool,
    editable: PropTypes.bool,
    onEditionClick: PropTypes.func,
    profileInfo: PropTypes.shape({
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        phone_number: PropTypes.string,
        email: PropTypes.string,
    }),
    generalError: PropTypes.string,
};

export default formHandlerHOC({
    rules: {
        name: 'required',
        surnames: 'required',
        phone: 'required|us_phone',
        email: '',
    },
    validationMessages: {
        required: 'Required',
    },
    initialData: ({ profileInfo }) => {
        if (profileInfo) {
            return {
                name: profileInfo.first_name || '',
                surnames: profileInfo.last_name || '',
                phone: profileInfo.phone_number || '',
                email: profileInfo.email || '',
            }
        }
    },
    shouldRefresh: (props, prevProps) => prevProps && props.profileInfo !== prevProps.profileInfo,
})(ProfileEditor);

